module.exports = __webpack_public_path__ + "img/example_id.13d1efdb.jpg";